import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import Box, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { webPaths } from '../../routes/paths';
import Helmet from '../../components/Helmet';
import Profile from '../../components/Profile';
import { useGetMyProfileQuery } from '../../services/users';

export interface HomeProps extends MuiBoxProps {}

export const StudentProfile = ({ className }: HomeProps) => {
  const navigate = useNavigate();

  const {
    data: user,
    isLoading: loadingUser,
    isUninitialized: uninitialisedUser,
  } = useGetMyProfileQuery();

  useEffect(() => {
    if (!user && !loadingUser && !uninitialisedUser) {
      localStorage.removeItem('token');
      navigate(`${webPaths.root}`, { replace: true });
    }
  }, [user]);

  return (
    <>
      <Helmet />

      <Profile />
    </>
  );
};

StudentProfile.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

StudentProfile.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(StudentProfile)(
  ({ theme }) => `
`,
);
